import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import Separator from '../separator/Separator';

const SlipThree = () => {
    return (
        <div className="rn-splite-style bg-color-blackest">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="image-container">
                            <img src="./images/split/video-thumb.jpg" style={{ objectFit: 'cover', }} alt="split Images" width="1366" height="667" />
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title" style={{ position: 'relative', fontSize: '4rem', marginBottom: '4rem' }}>
                                    CRAFTING DIGITAL EXPERIENCES
                                </h4>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title" style={{ position: 'relative', paddingLeft: '3.5rem' }}>
                                    <span style={{ color: '#36a2d6', position: 'absolute', top: '-5%', left: '0' }}>●</span>DISCOVERY
                                </h4>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description">We start with in-depth consultations to understand your vision, goals, and challenges, ensuring a tailored approach to meet your needs.</p>
                            </ScrollAnimation>
                            <div style={{ marginBottom: '2rem', marginTop: '-0.5rem' }}>
                                <Separator />
                            </div>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title" style={{ position: 'relative', paddingLeft: '3.5rem' }}>
                                    <span style={{ color: '#36a2d6', position: 'absolute', top: '-5%', left: '0' }}>●</span> IDEATION
                                </h4>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description">With your goals in mind, our team of designers, developers, and strategists brainstorm innovative solutions, exploring concepts that align with your vision.</p>
                            </ScrollAnimation>
                            <div style={{ marginBottom: '2rem', marginTop: '-0.5rem' }}>
                                <Separator />
                            </div>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title" style={{ position: 'relative', paddingLeft: '3.5rem' }}>
                                    <span style={{ color: '#36a2d6', position: 'absolute', top: '-5%', left: '0' }}>●</span> EXECUTION
                                </h4>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description">With the concept finalized, our team works passionately and strategically to execute your project using the latest technologies, ensuring precision and perfection.</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlipThree;